<template>
  <div class="houseList">
    <div class="top">
      <div class="top_title">
        <div class="room-name">
          <span class="fy">房源</span>
          <span class="cz">商铺出租</span>
        </div>
      </div>
      <div class="searchBox">
        <a-form :model="searchForm" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="downShow">
          <a-row style="padding-left: 53px">
            <a-col :span="4">
              <a-form-item class="search">
                <a-input v-model="searchForm.userName" placeholder="智能搜索">
                  <a-icon slot="prefix" type="search" />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" style="margin-left: 15px">
              <a-button
                class="btn"
                style="background-color: var(--ThemeColor); color: white; border: none; margin-left: 20px"
                type="primary"
                @click="searchBtn"
              >查询</a-button
              >
            </a-col>
          </a-row>
          <a-row style="padding-left: 20px">
            <a-col :span="5">
              <a-form-item label="区域">
                <a-select v-model="form.districtName" @change="regionChange">
                  <a-select-option v-for="item in districtData" :key="item.id" :value="item.districtFullName">{{
                    item.districtFullName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="状态">
                <a-select v-model="form.houseStatus">
                  <a-select-option :value="item.dictLabel" v-for="item in houseStatusData" :key="item.dictLabel">{{
                    item.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="面积" class="mj" :style="{ display: 'inline-block', width: '100%' }">
                <a-input style="width: 120px" v-model="form.startAcreage" />-
                <a-input style="width: 120px" v-model="form.endAcreage" />m²
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="日期" class="rq">
                <a-select
                  v-model="searchForm.rqselect"
                  style="width: 130px; margin-right: 3px"
                  @change="rqselectMethod"
                >
                  <a-select-option value="all" key="0">全部</a-select-option>
                  <a-select-option value="gengjin" key="1">最后跟进日期</a-select-option>
                  <a-select-option value="luru" key="2">录入日期</a-select-option>
                </a-select>
                <a-date-picker :disabled="rqflag" style="width: 118px" v-model="searchForm.rqstart" />-
                <a-date-picker :disabled="rqflag" style="width: 118px" v-model="searchForm.rqend" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="padding-left: 20px">
            <a-col :span="5">
              <a-form-item label="商圈">
                <a-select v-model="form.businessDistrictName" @change="businessDistrictMethod">
                  <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.businessDistrictName">{{
                    item.businessDistrictName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="可否餐饮">
                <a-select v-model="form.alloweCateringTypeId">
                  <a-select-option v-for="item in repastType" :key="item.dictSort" :value="item.dictValue">{{
                    item.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="类型">
                <a-select v-model="form.shopType">
                  <a-select-option v-for="item in shopType" :key="item.dictValue" :value="item.dictValue">{{
                    item.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="租金范围" class="zj" :style="{ display: 'inline-block', width: '100%' }">
                <a-input style="width: 70px" v-model="form.startRentFee" />-
                <a-input v-model="form.endRentFee" style="width: 70px" />元/月
                <span class="rzj" :class="{ zjselect: zujinfalg }" @click="zujin(1)">日租金</span>
                <span class="rzj" :class="{ zjselect: !zujinfalg }" @click="zujin(2)">月租金</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="padding-left: 20px">
            <a-col :span="5">
              <a-form-item label="街道">
                <a-select v-model="form.streetName" @change="StreetMethod">
                  <a-select-option v-for="item in StreetData" :key="item.id" :value="item.streetFullName">{{
                    item.streetFullName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="楼层" :style="{ display: 'inline-block', width: '100%' }">
                <a-select v-model="form.dictLabel">
                  <a-select-option v-for="item in floorData" :key="item.dictLabel" value="shanghai">
                    {{ item.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="维护人">
                <a-select v-model="newForm.deptId" style="width: 49%; margin-right: 3px">
                  <a-select-option v-for="item in deptListData" :key="item.deptId" :value="item.deptId">{{
                    item.deptName
                  }}</a-select-option>
                </a-select>
                <a-select v-model="form.accendantId" style="width: 49%">
                  <a-select-option :value="deptListData.leader">{{ deptListData.leader }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div style="text-align: right; padding-right: 143px">
            <a-button class="btn" type="primary" @click="addHouse">新增房源</a-button>
            <a-button
              class="btn"
              style="margin-left: 20px; border: 1px solid var(--ThemeColor); color: var(--ThemeColor)"
              @click="reset"
            >重置</a-button
            >
          </div>
        </a-form>
        <a-row style="text-align: center; color: #628dad">
          <p>
            更多
            <a-icon type="up" @click="downShow = true" v-if="!downShow" />
            <a-icon type="down" @click="downShow = false" v-if="downShow" />
          </p>
        </a-row>
      </div>
    </div>
    <div class="midhr"></div>
    <div class="content">
      <a-tabs type="card" class="menu" @change="HouseMethod">
        <a-tab-pane key="1" tab="全部房源">
          <a-row class="serachmenu">
            <div style="display: flex; align-items: center; width: 100px">
              <span style="margin-right: 10px">元/月</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span style="margin-right: 10px">
                元/m²/月
              </span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 110px">
              <span style="margin-right: 5px; width: 56px">带看</span>
              <a-select v-model="form.region" style="width: 100%">
                <a-select-option value="shanghai">本周</a-select-option>
                <a-select-option value="beijing">有效</a-select-option>
                <a-select-option value="beijing">我租</a-select-option>
              </a-select>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span style="margin-right: 10px">面积</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span style="margin-right: 10px">盘别</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
          </a-row>
          <houseListVue :records="records"></houseListVue>
        </a-tab-pane>
        <a-tab-pane key="2" tab="我的房源"></a-tab-pane>
        <a-tab-pane key="3" tab="门店房源"></a-tab-pane>
        <a-tab-pane key="4" tab="公盘">
          <a-row class="serachmenu">
            <div style="display: flex; align-items: center; width: 100px">
              <span>元/月</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span>
                元/m²/月
              </span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span>带看</span>
              <a-select v-model="form.region" style="width: 50%">
                <a-select-option value="shanghai">本周</a-select-option>
                <a-select-option value="beijing">有效</a-select-option>
                <a-select-option value="beijing">我租</a-select-option>
              </a-select>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span>面积</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
            <div style="display: flex; align-items: center; width: 100px">
              <span>盘别</span>
              <div class="icons">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </div>
            </div>
          </a-row>
          <a-row class="menudetail">
            <a-col :span="8" style="display: flex; height: 100%">
              <div class="img">
                <img src="../../houses/list/ti.png" />
                <p style="text-align: center; color: black; font-size: 15px">A0839271</p>
              </div>
              <div class="title" style="margin-left: 20px">
                <p class="name">{{ records.businessDistrictName }}</p>
                <p>{{ records.streetName }}</p>
                <p>档口摊位</p>
                <p class="btn">
                  <span class="green">拒餐饮</span>
                  <span class="yellow">转角铺</span>
                  <span class="red">停车场</span>
                </p>
              </div>
            </a-col>
            <a-col :span="3" style="margin-top: 25px">
              <div style="color: black">
                <p style="color: #ff725b; font-weight: bold">3万/月</p>
                <p>
                  239/m²/月
                </p>
                <p>
                  99/m²/天
                </p>
              </div>
            </a-col>
            <a-col :span="3" style="margin-top: 25px">
              <div style="color: black">
                <p style="font-weight: bold">
                  建:35m²,实:32m²
                </p>
                <p>面宽:5m,层高:3m</p>
                <p>1层，共3层</p>
              </div>
            </a-col>
            <a-col :span="3" style="margin-top: 25px">
              <div style="color: black">
                <p style="font-weight: bold">10月30日更进</p>
                <p>三次带看</p>
              </div>
            </a-col>
            <a-col :span="3" style="margin-top: 25px">
              <div style="color: black">
                <p style="font-weight: bold">经纪人A</p>
                <p>11月12日录入</p>
              </div>
            </a-col>
            <a-col :span="2" style="margin-top: 45px">
              <a-button
                class="btn"
                type="primary"
                style="background-color: #26ca0b; border-radius: 20px; border: none; font-size: 12px"
              >公盘</a-button
              >
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="5" tab="即将掉盘"></a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import houseListVue from '@/components/houseList/houseList.vue'
import houseApi from '@/api/system/houses/house.js'
export default {
  components: {
    houseListVue
  },
  data () {
    return {
      // 信息
      AllList: [],
      // 日期控制禁用
      rqflag: true,
      // 租金切换
      zujinfalg: true,
      // 列表数据
      records: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 查询表单
      searchForm: {
        rqselect: 'all',
        rqstart: '',
        rqend: ''
      },
      form: {
        accendantId: '',
        alloweCateringTypeId: '',
        businessDistrictId: '',
        dateType: '',
        districtId: '',
        endAcreage: '',
        endInMoreNum: '',
        endRentFee: null,
        endTime: '',
        hourseSort: 1,
        houseFloor: '',
        houseResourceType: 1,
        houseStatus: '',
        isAsc: '',
        orderByColumn: '',
        pageNum: 1,
        pageSize: 1,
        search: '',
        shopType: '',
        sortType: 'ASC',
        startAcreage: '',
        startInMoreNum: '',
        startRentFee: null,
        startTime: '',
        streetId: '',
        transferFee: ''
      },
      // 维护人 部门
      newForm: {
        deptId: ''
      },
      // 查询框更多按钮事件
      downShow: true,
      // 房源状态(有效,已租,我租,不租,错误)
      houseStatusData: [],
      // 区域列表
      districtData: [],
      // 商圈列表
      businessDistrict: [],
      // 商铺类型
      shopType: [],
      // 街道列表
      StreetData: [],

      // 楼层数
      floorData: [],
      // 餐饮类型
      repastType: [],
      // 人员部门
      PersonGav: [],
      a: null,
      // 维护人所属部门id
      PersonId: '',
      // 部门列表
      deptListData: [],
      // 部门对应人员
      depPerson: []
    }
  },
  created () {
    this.houseList()
    // 获取部门
    this.getDep()
    // 房源状态
    this.getDicts('house_status').then((res) => {
      // console.log(res)
      if (res.code == 200) {
        this.houseStatusData = res.data
        console.log('房源状态', this.houseStatusData)
      }
    })
    // 商铺类型
    this.getDicts('shop_type').then((res) => {
      // console.log(res)
      if (res.code == 200) {
        this.shopType = res.data
        console.log('商铺类型', this.shopType)
      }
    })
    // 楼层数
    this.getDicts('floor_num').then((res) => {
      // console.log(res)
      if (res.code == 200) {
        this.floorData = res.data
        console.log('楼层数', this.floorData)
      }
    })
    // 维护人所属部门id
    this.getDicts('related_personne_type').then((res) => {
      if (res.code == 200) {
        if (res.code == 200) {
          this.PersonGav = res.data
          this.a = this.PersonGav.find((item) => {
            return item.dictLabel == '维护人'
          })
          console.log('res', this.a)
          this.PersonId = a.dictSort
        }
      }
    })
    // 区域列表
    this.getDistrict()

    // 餐饮类型
    this.getDicts('repast_type').then((res) => {
      // console.log(res)
      if (res.code == 200) {
        this.repastType = res.data
        console.log('餐饮类型', this.repastType)
      }
    })
  },

  methods: {
    // 查询
    searchBtn () {
      this.houseList()
    },
    // 重置
    reset () {
      for (const i in this.form) {
        this.form.i = ''
      }
    },
    // 房源信息查询列表
    houseList () {
      houseApi.houseInfoList(this.form).then((res) => {
        console.log('房源列表11111', res)
        if (res.code == 200) {
          // this.AllList = res.data
          this.records = res.data.records
          console.log('房源列表', this.records)
        } else {
          this.$message.warning('房源信息获取失败')
        }
      })
    },
    // 区域列表
    getDistrict () {
      houseApi.district({ districtFullName: '', districtShortName: '' }).then((res) => {
        if (res.code == 200) {
          this.districtData = res.data
          console.log('区域', this.districtData)
          // this.districtData = res.data
        }
      })
    },
    // 获取区域ID

    regionChange (val) {
      const regionChild = this.districtData.find((item) => {
        return item.districtFullName == val
      })
      this.form.districtId = regionChild.id
      this.getBusDistrict({ businessDistrictName: '', districId: regionChild.id })
    },
    // 商圈列表
    getBusDistrict (data) {
      console.log('商圈列表', data)
      houseApi.businessDistrict(data).then((res) => {
        if (res.code == 200) {
          this.businessDistrict = res.data
          this.getStreetMethod()
        }
      })
    },
    // 根据商圈名获取商圈id
    businessDistrictMethod (val) {
      // console.log('商圈3333333',val);
      const busId = this.businessDistrict.find((item) => {
        return item.businessDistrictName == val
      })
      this.form.businessDistrictId = busId.id
      // console.log('商圈3333333',busId);
    },
    // 日期选择事件
    rqselectMethod (val) {
      console.log('日期=' + val)
      this.searchForm.rqstart = ''
      this.searchForm.rqend = ''
      if (val == 'all') {
        this.rqflag = true
      } else {
        this.rqflag = false
      }
    },
    // 租金切换方法
    zujin (val) {
      console.log(val)
      if (val == 1) {
        this.zujinfalg = true // 为日租金
      } else {
        this.zujinfalg = false // 为月租金
      }
    },
    // 获取街道
    getStreetMethod () {
      const params = {
        businessDistrictId: this.form.businessDistrictId,
        streetFullName: '',
        streetShortName: ''
      }
      houseApi.GetStreetList(params).then((res) => {
        if (res.code == 200) {
          this.StreetData = res.data
        }
        console.log('街道2222', res)
      })
    },
    // 获取街道id StreetMethod
    StreetMethod (val) {
      const newStreet = this.StreetData.find((item) => {
        return item.streetFullName == val
      })
      this.form.streetId = newStreet.id
      // console.log(newStreet, '33455')
    },
    // 部门列表
    getDep () {
      houseApi.deptList(2).then((res) => {
        if (res.code == 200) {
          this.deptListData = res.data
          console.log('部门列表', this.deptListData)
          this.getDepPerson()
          // this.districtData = res.data
        }
      })
    },
    // 部门下属人员
    getDepPerson () {
      houseApi.depIdPerson(this.newForm.deptId).then((res) => {
        if (res.code == 200) {
          this.depPerson = res.data
          console.log('部门列表人员', this.depPerson)
          // this.districtData = res.data
        }
      })
    },
    // 房源分类列表
    HouseMethod (val) {
      console.log(val)
      ;(this.form.houseResourceType = val), this.houseList()
    },

    addHouse () {
      this.$router.push('/houses/add')
    }
  },
  watch: {
    'newForm.deptId': {
      handler () {
        this.getDepPerson()
      },
      depp: true
    }
  }
}
</script>

<style lang="less" scoped>
.houseList {
  background-color: white;
  .top {
    .top_title {
      padding: 20px;
      /* height: 100px; */
      display: flex;
      justify-content: center;
      align-content: center;
      .room-name {
        flex: 1;
        border-bottom: 1px solid #d9d9d9;
        .fy {
          font-size: 20px;
          font-weight: bold;
          color: #000;
        }
        .cz {
          color: var(--ThemeColor);
          font-weight: bold;
          margin-left: 15px;
        }
      }
      .btns {
        .btn {
          background-color: var(--ThemeColor);
          height: 50px;
          width: 102px;
          border-radius: 10px;
          border: none;
        }
      }
    }
    .searchBox {
      margin-top: 13px;
      /deep/ input {
        // border: 1px solid #bbbbbb;
      }
      /deep/ select {
        // border: 1px solid #bbbbbb;
      }
      .search {
        /deep/ .ant-col-14 {
          width: 100%;
        }
        /deep/ input {
          border-radius: 50px;
          height: 36px;
          width: 100%;
          // border: 1px solid black;
        }
      }
      .rzj {
        display: inline-block;
        border: 1px solid #c0c0c0;
        color: #c0c0c0;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
      }
      .zjselect {
        border: 1px solid red;
        color: red;
        background-color: #fff;
      }
      .yzj {
        display: inline-block;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        border: 1px solid #ee7556;
        color: #ee7556;
        background-color: #fef7f1;
        cursor: pointer;
      }
      .mj {
        /deep/.ant-col-14 {
          width: 72.333333%;
        }
      }
      .zj {
        /deep/ .ant-col-14 {
          width: 74.333333%;
        }
      }

      /deep/.ant-form-item {
        margin-bottom: 10px;
      }
    }

    .ant-row {
      .ant-col-6 {
        .ant-col-14 {
          width: 73%;
        }
      }
    }
  }
  .midhr {
    width: 100%;
    height: 5px;
    background-color: #f2f6fc;
  }
  .content {
    .menu {
      // .menudetail {
      //     margin-top: 20px;
      //     // height: 250px;
      //     border-bottom: 2px solid #f2f6fc;
      //     width: 100%;
      //     display: flex;
      //     justify-content: center;
      //     padding-bottom: 20px;
      // }
    }

    /deep/.serachmenu {
      display: flex;
      align-items: center;
      float: right;
      margin-bottom: 30px;
      width: 900px;
      justify-content: space-between;
      color: #828282;
      font-size: 15px;
      font-weight: bold;
      margin-right: 71px;
      padding-top: 20px;
    }
    padding-top: 20px;
    /deep/.ant-tabs-nav-scroll {
      height: 37px;
    }
    /deep/.ant-tabs-nav-container {
      margin-left: -20px;
      margin-bottom: -3px;
    }

    /deep/ .ant-tabs-bar {
      border-bottom: 3px solid var(--ThemeColor);
      padding-left: 20px;
      width: 98%;
      margin: 0 auto;
    }

    /deep/.ant-tabs-tab {
      margin-right: 0px;
      border: none;
      background-color: #ffffff;
    }
    /deep/ .ant-tabs-tab-active {
      background-color: var(--ThemeColor);
      color: #fff;
      border-radius: 5px;
    }
    .icons {
      display: flex;
      flex-wrap: wrap;
      width: 20px;
      height: 25px;
    }
  }
  .rq {
    /deep/ .ant-col-14 {
      width: 80%;
    }
  }
}
</style>
